import { useEffect } from 'react';

const BASE_URL = 'https://physiotherapie-oliverbauer.com';
const DEFAULT_IMAGE = `${BASE_URL}/og-image.jpg`;

const ensureTag = (selector, create) => {
  if (typeof document === 'undefined') {
    return null;
  }
  let tag = document.head.querySelector(selector);
  if (!tag && typeof create === 'function') {
    tag = create();
    document.head.appendChild(tag);
  }
  return tag;
};

const setMeta = (name, content) => {
  if (typeof document === 'undefined' || !content) return;
  const meta = ensureTag(`meta[name="${name}"]`, () => {
    const element = document.createElement('meta');
    element.name = name;
    return element;
  });
  if (meta) meta.setAttribute('content', content);
};

const setPropertyMeta = (property, content) => {
  if (typeof document === 'undefined' || !content) return;
  const meta = ensureTag(`meta[property="${property}"]`, () => {
    const element = document.createElement('meta');
    element.setAttribute('property', property);
    return element;
  });
  if (meta) meta.setAttribute('content', content);
};

const resolveImageUrl = (image) => {
  if (!image) return DEFAULT_IMAGE;
  if (image.startsWith('http')) return image;
  if (image.startsWith('/')) return `${BASE_URL}${image}`;
  return DEFAULT_IMAGE;
};

const Seo = ({ title, description, canonical = '/', robots = 'index,follow', image = DEFAULT_IMAGE }) => {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    if (title) {
      document.title = title;
      setPropertyMeta('og:title', title);
      setMeta('twitter:title', title);
    }

    if (description) {
      setMeta('description', description);
      setPropertyMeta('og:description', description);
      setMeta('twitter:description', description);
    }

    if (robots) {
      setMeta('robots', robots);
    }

    const canonicalUrl = canonical.startsWith('http') ? canonical : `${BASE_URL}${canonical}`;
    const canonicalLink = ensureTag('link[rel="canonical"]', () => {
      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      return link;
    });
    if (canonicalLink) canonicalLink.setAttribute('href', canonicalUrl);
    setPropertyMeta('og:url', canonicalUrl);

    const imageUrl = resolveImageUrl(image);
    setPropertyMeta('og:image', imageUrl);
    setMeta('twitter:image', imageUrl);
    setMeta('twitter:card', 'summary_large_image');
  }, [title, description, canonical, robots, image]);

  return null;
};

export default Seo;
